<template>
  <div class="columns is-multiline">
    <div class="column is-one-third">
      <div class="field">
        <label class="label">Τιμή Αγοράς *</label>
        <div class="control">
          <input
            v-validate="'required|excluded:0'"
            :value="newProduct.buy_price"
            disabled
            class="input"
            type="number"
            min="0"
            step="0.01"
            name="buy_price"
            @input="updatePrice"
          />
          <p v-show="errors.has('buy_price')" class="help is-danger">
            Εισάγετε τιμή αγοράς
          </p>
        </div>
      </div>
    </div>

    <div class="column is-one-third">
      <div class="field">
        <label class="label">Π.Λ. Τιμή Πώλησης *</label>
        <div class="control">
          <input
            v-validate="'required|excluded:0'"
            :value="newProduct.sell_price"
            disabled
            class="input"
            type="number"
            min="0"
            step="0.01"
            name="sell_price"
            @input="updatePrice"
          />
          <p v-show="errors.has('sell_price')" class="help is-danger">
            Εισάγετε τιμή πώλησης
          </p>
        </div>
      </div>
    </div>

    <div class="column is-one-third">
      <div class="field">
        <label class="label">Τελική Τιμή *</label>
        <div class="control">
          <input
            v-validate="'required|excluded:0'"
            :value="newProduct.final_price"
            disabled
            class="input"
            type="number"
            min="0"
            step="0.01"
            name="final_price"
            @input="updatePrice"
          />
          <p v-show="errors.has('final_price')" class="help is-danger">
            Εισάγετε τελική τιμή
          </p>
        </div>
      </div>
    </div>

    <div class="column is-half">
      <div class="field">
        <label class="label">Ποσοστό Έκπτωσης *</label>
        <div class="control">
          <input
            v-validate="'required|min_value:0'"
            :value="newProduct.discount"
            class="input"
            type="number"
            min="0"
            step="0.01"
            name="discount"
            @input="updatePrice"
          />
          <p v-show="errors.has('discount')" class="help is-danger">
            Εισάγετε ποσοστό έκπτωσης
          </p>
        </div>
      </div>
    </div>

    <div class="column is-half">
      <div class="field">
        <label class="label">Τελική Τιμή Bundle *</label>
        <div class="control">
          <input
            v-validate="'required|excluded:0'"
            :value="newProduct.bundle_price"
            disabled
            class="input"
            type="number"
            min="0"
            step="0.01"
            name="bundle_price"
            @input="updatePrice"
          />
          <p v-show="errors.has('bundle_price')" class="help is-danger">
            Εισάγετε τελική τιμή bundle
          </p>
        </div>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import _pick from 'lodash/pick';
import _round from 'lodash/round';

export default {
  inject: ['$validator'],
  props: {
    product: Object,
  },
  data: () => ({
    newProduct: {},
  }),
  watch: {
    product: {
      handler(newVal) {
        this.setProduct(newVal);
      },
      deep: true,
    },
  },
  created() {
    this.setProduct(this.product);
  },
  methods: {
    setProduct(product) {
      this.newProduct = _pick(product, [
        'buy_price',
        'sell_price',
        'final_price',
        'discount',
        'bundle_price',
      ]);
    },
    updatePrice(e) {
      /* eslint-disable camelcase, prefer-const */
      let { name, value } = e.target;
      value = Number(value);
      let price = {
        [name]: value,
      };

      /* eslint-disable no-restricted-globals */
      if (name === 'discount') {
        const { final_price } = this.newProduct;
        const newBundlePrice = _round(
          final_price - (value * final_price) / 100,
          2,
        );

        price = {
          ...price,
          bundle_price: isNaN(newBundlePrice) ? 0 : newBundlePrice,
        };
      }

      this.$emit('updatePrice', price);
    },
  },
};
</script>
